import React from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label } from 'recharts';
import '../styles/ScatterPlotWidget.css'; // We'll create this CSS file next

// Custom Tooltip for Scatter Plot
const CustomScatterTooltip = ({ active, payload, xLabel, yLabel, xFormatter, yFormatter }) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload; // The actual data point object
        const xValue = data[payload[0].dataKey]; // Use dataKey to get the correct property
        const yValue = data[payload[1].dataKey];

        return (
            <div className="custom-scatterplot-tooltip">
                {data.title && <p className="title">{data.title}</p>} {/* Optional: Show post title */}
                <p className="label">{`${xLabel}: ${xFormatter(xValue)}`}</p>
                <p className="label">{`${yLabel}: ${yFormatter(yValue)}`}</p>
                {/* Add other relevant info from 'data' if needed */}
            </div>
        );
    }
    return null;
};

const ScatterPlotWidget = ({
    title,
    data, // Expects array of objects with xKey, yKey, and potentially other post info
    xKey, // Key for x-axis data in each object
    yKey, // Key for y-axis data in each object
    xLabel,
    yLabel,
    pointColor = '#8884d8',
    onPointClick = () => {},
    xFormatter = (value) => value, // Formatter for x-axis ticks and tooltip
    yFormatter = (value) => value, // Formatter for y-axis ticks and tooltip
}) => {

    // Filter data to ensure both xKey and yKey are present and valid numbers
    const plotData = data.filter(
        (d) => 
            d &&
            typeof d[xKey] === 'number' && !isNaN(d[xKey]) &&
            typeof d[yKey] === 'number' && !isNaN(d[yKey])
    );

    if (plotData.length === 0) {
        return <div className="scatterplot-widget">No valid data points available for {title}.</div>;
    }

    return (
        <div className="scatterplot-widget">
            <h2>{title}</h2>
            <div className="scatterplot-chart-container">
                <ResponsiveContainer width="100%" height={400}> {/* Increased height for scatter */}
                    <ScatterChart
                        margin={{ top: 20, right: 30, bottom: 40, left: 40 }} // Adjust margins for labels
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                        <XAxis 
                            type="number" 
                            dataKey={xKey} 
                            name={xLabel}
                            tickFormatter={xFormatter} 
                            domain={['dataMin', 'dataMax']} // Auto domain or specify fixed
                            tick={{ fontSize: 12 }}
                            dy={10} // Offset ticks down
                        >
                             <Label value={xLabel} offset={-25} position="insideBottom" style={{ textAnchor: 'middle', fontSize: '12px' }} />
                        </XAxis>
                        <YAxis 
                            type="number" 
                            dataKey={yKey} 
                            name={yLabel}
                            tickFormatter={yFormatter}
                            domain={['dataMin', 'dataMax']} // Auto domain or specify fixed
                            tick={{ fontSize: 12 }}
                            dx={-5} // Offset ticks left
                        >
                             <Label value={yLabel} angle={-90} offset={-25} position="insideLeft" style={{ textAnchor: 'middle', fontSize: '12px' }} />
                        </YAxis>
                        <Tooltip 
                            cursor={{ strokeDasharray: '3 3' }} 
                            content={<CustomScatterTooltip xLabel={xLabel} yLabel={yLabel} xFormatter={xFormatter} yFormatter={yFormatter} />} 
                        />
                        <Scatter 
                            name="Posts" // Name for the legend/tooltip group
                            data={plotData} 
                            fill={pointColor}
                            onClick={(props) => onPointClick(props.payload)} // Pass the original data payload on click
                            cursor="pointer"
                        />
                    </ScatterChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default ScatterPlotWidget; 